import type { RouteObject } from 'react-router';
import { RequirePermission } from '../../hooks/useAuth';
import { AuditPage } from './AuditPage';

export const routes: RouteObject[] = [
  {
    path: '/audit',
    element: (
      <RequirePermission permission="audit:read">
        <AuditPage />
      </RequirePermission>
    ),
  },
];
